<template>
  <v-container>
    <v-navigation-drawer
      app
      temporary
      v-model="drawer"
      class="hidden-md-and-up"
    >
      <v-list nav>
        <v-list-item
          v-for="(item, i) in menuItems"
          :key="`navdrawer${i}`"
          :to="item.route"
          active-class="teal--text text--accent-4"
        >
          <v-list-item-action>
            <v-icon v-html="item.icon"></v-icon>
          </v-list-item-action>
          <v-list-item-action>
            <v-list-item-title v-text="item.title"></v-list-item-title>
          </v-list-item-action>
        </v-list-item>
      </v-list>
      <v-list-item v-if="isUserAuthentificated">
        <v-list-item-action>
          <v-icon class="orange--text">mdi mdi-door-closed-lock</v-icon>
        </v-list-item-action>
        <v-list-item-action>
          <v-list-item-title @click="signout">Выйти</v-list-item-title>
        </v-list-item-action>
      </v-list-item>
    </v-navigation-drawer>
     
      <!-- fade-img-on-scrol -->
       <!-- scroll-target="#scrolling-techniques-2" -->
      <!-- :scroll-target="scrollVal" -->
      
    <!-- src="https://firebasestorage.googleapis.com/v0/b/dog-shelter-d9a79.appspot.com/o/images%2F2NzhhVJQxfM.jpgZYKcLst8DuiWgR6BrkTK?alt=media&token=ebcb00be-eb1f-4a95-be2f-cb98b66b63ba" -->
    <v-app-bar
      shrink-on-scroll
      :src="require('../assets/HeaderBG.jpg')"
      app
      dark
      elevation="6"
      class="teal lighten-1"
      fade-img-on-scroll
      height="245"
      animation="smooth"
    >
      <template v-slot:img="{ props }" >
        <v-img 
          v-bind="props"
          gradient="to top right, rgba(19,84,122,.1), rgba(128,208,199,.6)"
          position="left top"
          aspect-ratio="1.5"
        >
        </v-img>
      </template>

      <v-app-bar-nav-icon 
        @click.stop="drawer = !drawer"
        class="hidden-md-and-up"
      ></v-app-bar-nav-icon>


      <router-link to="/" style="cursor: pointer" tag="span">
      <v-toolbar-title class="pt-0" >
        <v-card
          class="mx-auto"
          tile
          color="transparent"
          elevation="0"
        >
            <v-row
              align="center"
              class="ml-3"
            >
              <v-col
                align-self="start"
                class="pa-0 ma-0"
                cols="2"
              >
                <v-avatar
                  class="mt-1"
                  size="45"
                >
                  <v-img src="../assets/ShelterLogo200x195.jpg" contain></v-img>
                </v-avatar>
              </v-col>
              <v-col class="py-0 ma-0" cols="10">
                  <v-list-item
                    dark
                  >
                    <v-list-item-content class="pt-1 mt-0 ">
                      <v-list-item-title class="title font-weight-bold ">
                      Право на ЖИЗНЬ
                      </v-list-item-title>
                      <v-list-item-subtitle class="subtitle-1 font-weight-bold">приют в Полоцке</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
              </v-col>
            </v-row>
        </v-card>



   
        </v-toolbar-title>

        <!-- <v-avatar>
          <img
            src="../assets/ShelterLogo200x225.jpg"
            alt="John"
          >
         </v-avatar>
        <v-toolbar-title v-text="'Право на ЖИЗНЬ'"></v-toolbar-title>
        <v-subheader class="hidden-sm-and-down" v-text="'Приют в Полоцке'"></v-subheader> -->
         
      </router-link>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down" >
        <v-btn
          v-for="(item, i) in menuItems"
          :key="`menuitem${i}`"
          :to="item.route"
          elevation="4"
          class="teal lighten-1"
          max-height="50"
         
          
        >
          <v-icon size="1.5em" left v-html="item.icon"></v-icon>
          {{ item.title }}
        </v-btn>
        <v-btn
          text
          elevation="4"
          class="teal lighten-1 "
          @click="signout"
          v-if="isUserAuthentificated"
          max-height="50"
        >
          <v-icon size="1.5em" class="orange--text" left>mdi mdi-door-closed-lock</v-icon>
          Выйти
        </v-btn>
      </v-toolbar-items>
    </v-app-bar>

    <!-- <v-sheet
      id="scrolling-techniques-2"
      class="overflow-y-auto"
      max-height="200"
    >
      <v-container style="height: 500px;"></v-container>
    </v-sheet> -->

  </v-container>
</template>

<script>
export default {
  data() {
    return {
      drawer: false,
      // scrollVal: false,
    };
  },
  computed: {
    isUserAuthentificated() {
      return this.$store.getters.isUserAuthentificated;
    },

    menuItems() {
      return this.isUserAuthentificated
        ? [
            {
              icon: "mdi mdi-home",
              title: "Главная",
              route: "/",
            },
            {
              icon: "mdi mdi-paw",
              title: "Питомцы",
              route: "/dogs",
            },
            // {
            //     icon: 'mdi mdi-cat',
            //     title: 'Мяу-мяу!',
            //     route: '/cats'
            // },
            {
              icon: "mdi mdi-heart-multiple",
              title: "Милосердие",
              route: "/mercy",
            },
            {
              icon: "mdi mdi-alert-decagram-outline",
              title: "SOS ! ! !",
              route: "/sos",
            },
            {
              icon: "mdi mdi-phone-outline",
              title: "Контакты",
              route: "/contacts",
            },
            // {
            //   icon: "mdi mdi-monitor-star",
            //   title: "Кабинет",
            //   route: "/profile",
            // },
          ]
        : [
            {
              icon: "mdi mdi-home",
              title: "Главная",
              route: "/",
            },
            {
              icon: "mdi mdi-paw",
              title: "Питомцы",
              route: "/dogs",
            },
            // {
            //     icon: 'mdi mdi-cat',
            //     title: 'Мяу-мяу!',
            //     route: '/cats'
            // },
            {
              icon: "mdi mdi-heart-multiple",
              title: "Милосердие",
              route: "/mercy",
            },
            {
              icon: "mdi mdi-alert-decagram-outline",
              title: "SOS ! ! !",
              route: "/sos",
            },
             {
              icon: "mdi mdi-phone-outline",
              title: "Контакты",
              route: "/contacts",
            },
            {
              icon: "mdi mdi-door-open",
              title: "Вход",
              route: "/signin",
            },
            // {
            //   icon: "mdi mdi-account-plus",
            //   title: "Регистрация",
            //   route: "/signup",
            // },
          ];
    },

  // scrollFunction() {
  //   let me = this;
  //   this.$store.getters.getScroll;
  //   this.$store.dispatch('GET_SCROLL');
  //     if (document.body.scrollTop > 80 || document.documentElement.scrollTop > 80) {
  //       // document.getElementById("navbar").style.padding = "30px 10px";
  //       // document.getElementById("logo").style.fontSize = "25px";
  //       return me.scrollVal = true;
  //       // return console.log('good');
  //     } else {
  //       // document.getElementById("navbar").style.padding = "80px 10px";
  //       // document.getElementById("logo").style.fontSize = "35px";
  //       return console.log('bad');
  //     }
  //   }

  },

  methods: {
    signout() {
      this.$router.push("/").catch(() => {});
      this.$store.dispatch("SIGNOUT");
    },

    
  },

  // watch: {
  //   scrollFunction() {
  //     // window.onscroll = function() {this.scrollFunction()};
  //     this.$store.dispatch('GET_SCROLL');
  //     return this.$store.getters.getScroll;
  //   }
  // }
  




};
</script>

<style scoped>
</style>
